import { gql } from '@apollo/client';

/**
 * Keystone operations live beside the container that runs them, colocated the
 * way the README asks for: a component states the data it needs and Apollo
 * batches, caches and dedupes the fetching.
 *
 * `me` is the only resolver Keystone exposes to an identity token today. As
 * the harness grows, add operations here (or in a sibling file per domain) —
 * not a REST wrapper.
 */
export const ME_QUERY = gql`
  query Me {
    me {
      id
    }
  }
`;

export interface MeQueryResult {
  me: { id: string };
}
